exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".header__siteHeader--3oiNE,.header__siteTitle--3LfnW{-webkit-box-sizing:border-box;box-sizing:border-box;font-family:Source Sans Pro,sans-serif}.header__siteHeader--3oiNE{background:-webkit-gradient(linear,left top,right top,from(#31bfce),to(#2580be));background:linear-gradient(90deg,#31bfce 0,#2580be);max-height:33.4375em;padding:14.375em 16px 7.8125em;padding:14.375em 1rem 7.8125em;text-align:center;width:100%}.header__siteTitle--3LfnW{color:#fff;font-family:Roboto Condensed,sans-serif;font-size:48px;font-size:3rem;font-weight:700;line-height:1.1875;margin-bottom:16px;margin-bottom:1rem}", ""]);

// exports
exports.locals = {
	"siteHeader": "header__siteHeader--3oiNE",
	"siteTitle": "header__siteTitle--3LfnW"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"sourceMap":true,"config":{"path":"/var/www/prb-datafinder/client/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./app/components/header/header.scss
// module id = 816
// module chunks = 0